export const goToExternalUrl = (url) => {
  return window.open(url, "_blank");
};
